import { EstacionPopup } from './estacion-popup';
import { PopupInfoItem } from './entity-popup.interface';

/**
 * Popup para estaciones de nutrientes.
 * Muestra datos de NPK, humedad y temperatura del suelo, conductividad eléctrica y pH.
 */
export class NutrientesPopup extends EstacionPopup {
  getBadgeText(): string {
    return `Estación de Nutrientes de ${this.entity.provider} (Id ${this.entity.provider_id})`;
  }

  getInfoItems(): PopupInfoItem[] {
    return [
      // Nutrientes NPK
      this.createSensorItem(this.entity.ac_n_last, 'N', 'water_do', 'mg/Kg'),
      this.createSensorItem(this.entity.ac_p_last, 'P₂O₅', 'water_do', 'mg/Kg'),
      this.createSensorItem(this.entity.ac_k_last, 'K₂O', 'water_do', 'mg/Kg'),

      // Humedad del suelo (4 niveles)
      this.createSensorItem(
        this.entity.soil_moisture1_last,
        'Humedad del suelo 1',
        'humidity_low',
        '%'
      ),
      this.createSensorItem(
        this.entity.soil_moisture2_last,
        'Humedad del suelo 2',
        'humidity_low',
        '%'
      ),
      this.createSensorItem(
        this.entity.soil_moisture3_last,
        'Humedad del suelo 3',
        'humidity_low',
        '%'
      ),
      this.createSensorItem(
        this.entity.soil_moisture4_last,
        'Humedad del suelo 4',
        'humidity_low',
        '%'
      ),

      // Temperatura del suelo (4 niveles)
      this.createSensorItem(
        this.entity.soil_temperature1_last,
        'Temperatura del suelo 1',
        'device_thermostat',
        '°C'
      ),
      this.createSensorItem(
        this.entity.soil_temperature2_last,
        'Temperatura del suelo 2',
        'device_thermostat',
        '°C'
      ),
      this.createSensorItem(
        this.entity.soil_temperature3_last,
        'Temperatura del suelo 3',
        'device_thermostat',
        '°C'
      ),
      this.createSensorItem(
        this.entity.soil_temperature4_last,
        'Temperatura del suelo 4',
        'device_thermostat',
        '°C'
      ),

      // Conductividad y pH
      this.createSensorItem(
        this.entity.ec_last,
        'Conductividad eléctrica',
        'water_ec',
        'mS/cm'
      ),
      this.createSensorItem(this.entity.ph_last, 'pH', 'water_ph'),
    ];
  }
}
